module.exports = __webpack_public_path__ + "static/media/ytcontentid.23a4ae42.jpg";